import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export function AccessDeniedPage(): JSX.Element {
  const navigate = useNavigate();
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="60vh"
    >
      <Typography variant="h4" gutterBottom>
        Access denied
      </Typography>
      <Typography variant="body1" color="text.secondary" gutterBottom>
        You do not have permission to access that page.
      </Typography>
      <Button variant="contained" onClick={() => navigate('/dashboard')} sx={{ mt: 2 }}>
        Return to dashboard
      </Button>
    </Box>
  );
}
